(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar-overlay.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar-overlay.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const Icon = svs.ui.ReactIcon;
setGlobal('svs.ticketgames.ticketUtility.components.TopBarOverlay', _ref => {
  var _ticketInfo$gameGuide;
  let _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    onCloseOverlay = _ref.onCloseOverlay,
    guides = _ref.guides,
    trackingLabel = _ref.trackingLabel;
  const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.components.useGameContext(),
    ticketInfo = _svs$ticketgames$tick.ticketInfo;
  const trackTopBarAction = svs.ticketgames.ticketUtility.utils.tracking.trackTopBarAction;
  const OverlayPage = svs.ticketgames.ticketUtility.components.OverlayPage;
  const overlayRef = useRef(null);
  const mounted = useRef(false);
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTabState = _useState2[1];
  const setActiveTab = tabName => {
    setActiveTabState(tabName);
    if (isActive && tabName) {
      trackTopBarAction("flik-".concat(tabName.toLowerCase()), trackingLabel);
    }
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldCloseOverlay = _useState4[0],
    setShouldCloseOverlay = _useState4[1];
  if (!(ticketInfo !== null && ticketInfo !== void 0 && (_ticketInfo$gameGuide = ticketInfo.gameGuide) !== null && _ticketInfo$gameGuide !== void 0 && _ticketInfo$gameGuide.guides.length) > 0) {
    return null;
  }
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect(() => {
    (guides === null || guides === void 0 ? void 0 : guides.length) > 0 && isActive && setActiveTab(activeTab || guides[0].tabName);
  }, [guides, isActive]);
  useEffect(() => {
    if (!isActive) {
      return;
    }
    if (!shouldCloseOverlay) {
      gsap.to(overlayRef.current, {
        x: 0,
        duration: 0.5,
        onComplete: () => {
          const activeTabElement = document.querySelector('.ts-top-bar-tab-active');
          activeTabElement === null || activeTabElement === void 0 || activeTabElement.focus();
        }
      });
    } else {
      gsap.to(overlayRef.current, {
        x: '100%',
        duration: 0.5,
        onComplete: () => {
          if (mounted.current) {
            onCloseOverlay();
            setShouldCloseOverlay(false);
          }
        }
      });
    }
  }, [isActive, shouldCloseOverlay]);
  if (!isActive) {
    return null;
  }
  return React.createElement("div", {
    className: "top-bar-overlay padding-bottom-2",
    ref: overlayRef,
    style: {
      transform: 'translateX(100%)'
    }
  }, React.createElement("div", {
    className: "bg-navy ts-top-bar-game-info"
  }, React.createElement(ItemsMenu, {
    branding: "tur",
    inverted: true
  }, React.createElement("a", {
    "aria-label": "St\xE4ng spelinformation",
    className: "ts-top-bar-tab margin-top-half padding-1",
    href: "",
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      setShouldCloseOverlay(true);
    },
    tabIndex: isActive ? 0 : -1
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "menu-left"
  })), guides.map((_ref2, i) => {
    let tabName = _ref2.tabName;
    return React.createElement(LinkItem, {
      className: "fc-white ts-top-bar-tab ".concat(activeTab === tabName && 'ts-top-bar-tab-active'),
      Component: "a",
      href: "",
      key: "".concat(tabName + i),
      label: tabName,
      onClick: e => {
        e.preventDefault();
        setActiveTab(tabName);
      },
      selected: activeTab === tabName,
      tabIndex: isActive ? 0 : -1
    });
  }))), React.createElement(OverlayPage, {
    guide: guides.find(_ref3 => {
      let tabName = _ref3.tabName;
      return tabName === activeTab;
    })
  }));
});

 })(window);